<template>
  <d-card class="card-small mb-4">

    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }}</h6>
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col>
            <d-form @submit.prevent="save" :validated="hasErrors">
              <d-form-row>

                <!-- Nome -->
                <d-col md="6" class="form-group">
                  <label for="feFirstName">Nome</label>
                  <d-form-input type="text" id="feFirstName" placeholder="Nome" v-model="model.name"/>
                </d-col>

                <!-- E-mail -->
                <d-col md="6" class="form-group">
                  <label for="feEmail">E-mail</label>
                  <d-form-input :state="hasErrorFiled('email')" type="email" id="feEmail" placeholder="E-mail" v-model="model.email" />
                  <d-form-invalid-feedback>E-mail é obrigatório</d-form-invalid-feedback>
                </d-col>

              </d-form-row>

              <d-form-row>

                 <!-- Old Password -->
                <d-col md="6" class="form-group">
                  <label for="feOldPassword">Senha antiga</label>
                  <d-form-input type="password" id="feOldPassword" placeholder="**********" v-model="model.old_password" />
                </d-col>

              </d-form-row>

              <d-form-row>

                <!-- Password -->
                <d-col md="6" class="form-group">
                  <label for="fePassword">Senha</label>
                  <d-form-input :state="hasErrorFiled('password')" type="password" id="fePassword" placeholder="**********" v-model="model.password" />
                  <d-form-invalid-feedback>As senhas não são iguais</d-form-invalid-feedback>
                </d-col>

                <!-- Password -->
                <d-col md="6" class="form-group">
                  <label for="fePasswordConfirmation">Confirmar senha</label>
                  <d-form-input :state="hasErrorFiled('password_confirmation')" type="password" id="fePasswordConfirmation" placeholder="**********" v-model="model.password_confirmation" />
                </d-col>

              </d-form-row>

              <d-button type="submit" class="btn-accent">Atualizar</d-button>

            </d-form>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import mixin from '_common/mixins/ValidateForm';
import UserService from '_services/rest/user';
import MODEL from './UserModel';

export default {
  name: 'user-account-details',
  mixins: [mixin],
  props: {
    title: {
      type: String,
      default: 'Perfil',
    },
    user: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      model: { ...MODEL },
      loading: false,
      errors: {
        email: { required: false },
        password: { required: false, equals: false, field: 'password_confirmation' },
        password_confirmation: { required: false, equals: false, field: 'password' },
      },
    };
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    save() {
      if (this.checkForm()) {
        this.loading = true;
        UserService.save(this.model)
          .then(response => {
            this.loading = false;
            this.activeAlert({ message: response.message, theme: (response.result) ? 'success' : 'danger' });
          });
      }
    },
  },
  mounted() {
    this.model = { ...this.user };
  },
};
</script>
